export default {
  tableHeader: {
    dataId: 'Funkcja',
    spearmanCorrelationCoeff: 'Współczynnik korelacji nieliniowej (Spearman)',
    pearsonCorrelationCoeff: 'Współczynnik korelacji liniowej (Pearson)',
  },
};
